'use client';
import { logoutUser } from '@/services/api/auth';
import { useAdminStore } from '@/store/admin';
import { useAuthStore } from '@/store/auth';
import { ApiErrorResponse } from '@/types/api/common';
import { useMutation } from '@tanstack/react-query';
import { useRouter } from 'next/navigation';

export const useLogout = () => {
  const router = useRouter();
  const clearAuth = useAuthStore((state) => state.clearAuth);
  const clearAdminAuth = useAdminStore((state) => state.clearAuth);
  return useMutation<unknown, ApiErrorResponse>({
    mutationFn: () => logoutUser(),
    onSuccess: () => {
      setTimeout(() => {
        router.replace('/sign-in');
        clearAuth();
        clearAdminAuth();
      }, 10);
    },
    onError: (error) => {
      router.replace('/sign-in');
      clearAuth();
      clearAdminAuth();
    },
  });
};
